import React from 'react';
import Lottie from 'react-lottie';
import Modal from '@common/modal';
import loading from '@graphic/loading.json';

import classnames from 'classnames/bind';
import styles from './loadingModal.module.scss';
const cx = classnames.bind(styles);

const options = {
  loop: true,
  autoplay: true,
  animationData: loading,
};

interface SaveLoadingModalProps {
  visible: boolean;
}

const SaveLoadingModal = ({ visible }: SaveLoadingModalProps) => {
  return (
    <Modal visible={visible}>
      <div className={cx('layer')}>
        <div className={cx('lottieWrap')}>
          <Lottie options={options} />
        </div>
        <em className={cx('title')}>역검 응시 결과를 저장하고 있어요.</em>
        <p className={cx('desc')}>결과가 저장될 때까지 최대 5분이 소요될 수 있어요.</p>
      </div>
    </Modal>
  );
};

export default SaveLoadingModal;
